import { filter } from 'lodash';
import { useEffect, useState } from 'react';
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Snackbar,
} from '@mui/material';
// components
import Iconify from '../../Components/iconify';

// sections
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';
import axiosInstance from '../../api/axiosInstance';

import NewUser from '../../Components/NewUser/NewUser';
import DeleteModal from '../../Components/deleteModal/DeleteModal';
import SnackbarComponent from '../../Components/Snackbar/Snackbar';




const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'surname', label: 'Surname', alignRight: false },
  { id: 'username', label: 'Username', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'busniess', label: 'Business', alignRight: false },

  { id: '' },
];


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}



export default function Users() {

  const [users, setUsers] = useState([])
  const [business, setBusiness] = useState([])
  const [loading, setLoading] = useState(true);
  const getBusiness = async () => {
    try {
      const res = await axiosInstance.get("/business")
      setBusiness(res.data)
    } catch (err) {
      console.log(err)
    }
  }

  const getUsers = async () => {
    setLoading(true)
    try {
      const res = await axiosInstance.get("/user")
      setUsers(res.data)
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUsers()
    getBusiness()
  }, [])

  const [open, setOpen] = useState(null);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = users;
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - 0) : 0;

  const filteredUsers = applySortFilter(users, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  const [newUser, setNewUser] = useState(false);
  const [toEditRow, setToEditRow] = useState(null)
  const [tempEditData, setTempEditData] = useState(null)

  const handleEditOpen = (row) => {
    setTempEditData(row)
  }

  const [deleteModal, setDeleteModal] = useState(false)

  const [openSanckbar, setOpenSnackBar] = useState(false);
  const [snackbarMsgType, setSnackbarMsgType] = useState({
    message: "",
    type: ""
  })

  const handleDelete = async () => {
    if (tempEditData !== null) { return }
    try {
      await axiosInstance.delete(`/user/${tempEditData.userid}`)
      setUsers(users.filter(u => u.userid !== tempEditData.userid))
      setTempEditData(null)
      setDeleteModal(false)
      handleCloseMenu()
      setOpenSnackBar(true)
      setSnackbarMsgType({
        message: "User Deleted Successfully",
        type: "success"
      })
    } catch (err) {
      console.log(err)
      setOpenSnackBar(true)
      setSnackbarMsgType({
        message: "Cant delete this user",
        type: "error"
      })
    }

  }

  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} mt={3}>
          <Typography variant="h4" gutterBottom>
            User
          </Typography>
          <Button variant="contained" onClick={() => setNewUser(true)} startIcon={<Iconify icon="eva:plus-fill" />}>
            New User
          </Button>
        </Stack>

        <Card>
          <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />
          <TableContainer sx={{ width: "100%", overflow: "auto", maxHeight: "500px" }}>
            <Table sx={{ overflow: "auto" }}>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={users.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  const { userId, name, surname, username, email, business } = row;
                  const selectedUser = selected.indexOf(name) !== -1;

                  return (
                    <TableRow hover key={userId} tabIndex={-1} role="checkbox" selected={selectedUser}>


                      <TableCell align="left">{name}</TableCell>

                      <TableCell align="left">{surname}</TableCell>
                      <TableCell align="left">{username}</TableCell>
                      <TableCell align="left">{email}</TableCell>
                      <TableCell align="left">{business?.name}</TableCell>

                      <TableCell align="right">
                        <IconButton size="large" color="inherit" onClick={(e) => { handleOpenMenu(e); handleEditOpen(row) }}>
                          <Iconify icon={'eva:more-vertical-fill'} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >
                        <Typography variant="h6" paragraph>
                          Not found
                        </Typography>

                        <Typography variant="body2">
                          No results found for &nbsp;
                          <strong>&quot;{filterName}&quot;</strong>.
                          <br /> Try checking for typos or using complete words.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>


          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => {
          setNewUser(true)
          setToEditRow(tempEditData)
          handleCloseMenu()
        }}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }} onClick={() => setDeleteModal(true)}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
      {
        newUser ? <NewUser setSnackbarMsgType={setSnackbarMsgType} setOpenSnackBar={setOpenSnackBar} setOpen={setNewUser} getUsers={getUsers} toEditRow={toEditRow} setToEditRow={setToEditRow} business={business} /> : ""
      }
      {
        deleteModal ? <DeleteModal setOpen={setDeleteModal} handleDelete={handleDelete} item="user" /> : ""
      }
      <SnackbarComponent open={openSanckbar} setOpen={setOpenSnackBar} message={snackbarMsgType.message} type={snackbarMsgType.type} />
    </>
  );
}
